import { systemApi } from '../../../redux/api/SystemApi';
import { IntroResponse } from '../types';


export const loginApi = systemApi.injectEndpoints({
    endpoints: (builder) => ({
        getIntro: builder.query<IntroResponse, string>({
            query: (code) => `introduce?introduceCode=${code}`,
            transformResponse: (response: { body: IntroResponse }, meta, arg) => {
                return response.body;
            }
        })

    })
})

export const { useLazyGetIntroQuery } = loginApi;